<div
  *ngIf="mode === 'edit'"
  class="sticky top-0 z-10 flex justify-end items-center gap-2 bg-white px-4 py-2 mb-4 -mx-4 -mt-4"
>
  <span
    *ngIf="createOrUpdateErrorHtml"
    class="text-red-500 text-xs truncate max-w-xs"
  >
    {{ createOrUpdateErrorHtml }}
  </span>
  <button
    pButton
    size="small"
    [disabled]="!isFormValid() || !formChanged"
    [loading]="(loadingUpdateRule$ | async) || false"
    [pTooltip]="getSubmitTooltip()"
    tooltipPosition="bottom"
    (click)="submitForm()"
    label="Envoyer"
    icon="pi pi-check"
  ></button>
</div>

<mat-stepper [linear]="false" #stepper (selectionChange)="onStepChange($event)">
  <!-- Step 1: Localisation -->
  <mat-step [hasError]="localisationHasErrors">
    <ng-template matStepLabel>
      <span [class.text-red-500]="localisationHasErrors"> Localisation </span>
    </ng-template>

    <div class="shadow-md border border-gray-200 rounded-xl p-2 mt-4">
      <app-localisation-step
        #localisationStep
        [formGroup]="modifyRuleFormGroup"
        [rule]="rule"
        [mode]="mode"
        [selectedLabelIds]="selectedLabelIds"
        (selectedLabelIdsChange)="onLabelSelectionChange($event)"
        [initialLabelIds]="initialLabelIds"
        [plantLocked]="plantLocked"
      ></app-localisation-step>
    </div>

    <div class="flex justify-between mt-4">
      <div></div>
      <div class="flex gap-2">
        <button
          *ngIf="mode === 'create' && showDrafts"
          pButton
          size="small"
          severity="secondary"
          (click)="saveDraft()"
          label="Enregistrer brouillon"
        ></button>
        <button
          *ngIf="mode === 'create'"
          pButton
          size="small"
          severity="secondary"
          (click)="resetForm()"
          label="Réinitialiser"
        ></button>
        <button
          pButton
          size="small"
          (click)="stepper.next()"
          label="Suivant"
          icon="pi pi-arrow-right"
          iconPos="right"
        ></button>
      </div>
    </div>
  </mat-step>

  <!-- Step 2: Paramètres -->
  <mat-step [hasError]="parametersHasErrors">
    <ng-template matStepLabel>
      <span [class.text-red-500]="parametersHasErrors"> Paramètres </span>
    </ng-template>

    <div class="shadow-md border border-gray-200 rounded-xl p-2 mt-4">
      <app-parameters-step
        #parametersStep
        [formGroup]="modifyRuleFormGroup"
        [rule]="rule"
        [mode]="mode"
        [prodStageValidationMessage]="prodStageValidationMessage"
      ></app-parameters-step>
    </div>

    <div class="flex justify-between mt-4">
      <button
        pButton
        size="small"
        severity="secondary"
        (click)="stepper.previous()"
        label="Précédent"
        icon="pi pi-arrow-left"
      ></button>
      <button
        pButton
        size="small"
        (click)="stepper.next()"
        label="Suivant"
        icon="pi pi-arrow-right"
        iconPos="right"
      ></button>
    </div>
  </mat-step>

  <!-- Step 3: Équations -->
  <mat-step [hasError]="equationsHasErrors">
    <ng-template matStepLabel>
      <span [class.text-red-500]="equationsHasErrors"> Équations </span>
    </ng-template>

    <div class="shadow-md border border-gray-200 rounded-xl p-2 mt-4">
      <app-equations-step
        #equationsStep
        [formGroup]="modifyRuleFormGroup"
        [rule]="rule"
        [mode]="mode"
      ></app-equations-step>
    </div>

    <div class="flex justify-between mt-4">
      <button
        pButton
        size="small"
        severity="secondary"
        (click)="stepper.previous()"
        label="Précédent"
        icon="pi pi-arrow-left"
      ></button>
      <button
        pButton
        size="small"
        (click)="stepper.next()"
        label="Suivant"
        icon="pi pi-arrow-right"
        iconPos="right"
      ></button>
    </div>
  </mat-step>

  <!-- Step 4: Gains -->
  <mat-step [hasError]="gainHasErrors">
    <ng-template matStepLabel>
      <span [class.text-red-500]="gainHasErrors"> Gains </span>
    </ng-template>

    <div class="shadow-md border border-gray-200 rounded-xl p-2 mt-4">
      <app-gain-formula-instances-step
        #gainStep
        [formGroup]="modifyRuleFormGroup"
        [rule]="rule"
        [mode]="mode"
        (stateChange)="onGainStateChange($event)"
      ></app-gain-formula-instances-step>
    </div>

    <div class="flex justify-between items-center mt-4">
      <button
        pButton
        size="small"
        severity="secondary"
        (click)="stepper.previous()"
        label="Précédent"
        icon="pi pi-arrow-left"
      ></button>
      <div class="flex items-center gap-2">
        <span
          *ngIf="createOrUpdateErrorHtml"
          class="text-red-500 text-xs truncate max-w-xs"
          >{{ createOrUpdateErrorHtml }}</span
        >
        <button
          pButton
          size="small"
          [disabled]="
            !isFormValid() ||
            (mode === 'edit' && !formChanged) ||
            (mode === 'create' && (creating$ | async))
          "
          [loading]="
            (mode === 'create' && (creating$ | async)) ||
            (mode === 'edit' && (loadingUpdateRule$ | async)) ||
            false
          "
          [pTooltip]="getSubmitTooltip()"
          tooltipPosition="top"
          (click)="submitForm()"
          [label]="mode === 'create' ? 'Soumettre' : 'Envoyer'"
          icon="pi pi-check"
        ></button>
      </div>
    </div>
  </mat-step>

  <!-- Step 5: Terminé -->
  <mat-step [editable]="false" [completed]="submitted">
    <ng-template matStepLabel>Terminé</ng-template>
    <div
      class="grid gap-1 mt-3 m-1 p-3 shadow-md border border-gray-200 rounded-xl place-items-center"
    >
      <ng-container
        *ngIf="
          (mode === 'edit' && (loadingUpdateRule$ | async)) ||
            (mode === 'create' && (creating$ | async));
          else resultTemplate
        "
        class="flex flex-col items-center"
      >
        <p-progressSpinner></p-progressSpinner>
        <div class="text-center w-full">
          <span class="block text-lg sm:text-base">
            {{
              mode === "create"
                ? "Création en cours..."
                : "Demande en cours de traitement. Veuillez patienter..."
            }}
          </span>
        </div>
      </ng-container>
    </div>

    <ng-template #resultTemplate>
      <div class="result-container mt-3">
        <ng-container
          *ngIf="isCreateOrUpdateRuleOk$ | async; else errorTemplate"
        >
          <div class="flex flex-col items-center">
            <div>
              <svg class="checkmark" viewBox="0 0 52 52">
                <circle
                  class="checkmark__circle"
                  cx="26"
                  cy="26"
                  r="25"
                  fill="none"
                />
                <path
                  class="checkmark__check"
                  fill="none"
                  d="M14 27l7.5 7.5L38 18"
                />
              </svg>
            </div>
            <div class="mt-2 text-center w-full">
              <span class="block text-lg sm:text-base">
                {{
                  mode === "create"
                    ? "La création de la règle a été effectuée avec succès !"
                    : "La modification de la règle a été effectuée avec succès !"
                }}
              </span>
            </div>
          </div>
        </ng-container>
        <ng-template #errorTemplate>
          <div class="flex flex-col items-center">
            <svg class="crossmark" viewBox="0 0 52 52">
              <circle
                class="crossmark__circle"
                cx="26"
                cy="26"
                r="25"
                fill="none"
              />
              <path
                class="crossmark__cross"
                fill="none"
                d="M16 16 36 36 M36 16 16 36"
              />
            </svg>
            <div class="mt-2 text-center w-auto">
              <span class="block text-lg sm:text-base">
                {{
                  mode === "create"
                    ? "La création de la règle a échoué !"
                    : "La modification de la règle a échoué !"
                }}
              </span>
              <ng-container *ngIf="createOrUpdateErrorHtml; else simpleError">
                <div
                  class="text-left bg-red-50 border-2 border-red-300 rounded-lg p-4 mt-2"
                >
                  <div
                    [innerHTML]="createOrUpdateErrorHtml"
                    class="text-red-500 p-2"
                  ></div>
                </div>
              </ng-container>
              <ng-template #simpleError>
                <span class="block text-lg sm:text-base">
                  {{
                    mode === "create"
                      ? (createErrorMessage$ | async)
                      : (selectRuleUpdateErrorMessage$ | async)
                  }}
                </span>
              </ng-template>
            </div>
          </div>
        </ng-template>
      </div>
    </ng-template>

    <div class="flex justify-between mt-2">
      <p-button
        size="small"
        severity="secondary"
        [disabled]="
          (mode === 'create' && (creating$ | async)) ||
          (mode === 'edit' && (loadingUpdateRule$ | async))
        "
        (click)="goBackToPreviousStep()"
        label="Précédent"
        icon="pi pi-arrow-left"
      >
      </p-button>
      <p-button size="small" (click)="closeDialog()" label="Fermer"></p-button>
    </div>
  </mat-step>
</mat-stepper>

<!-- Drafts section for create mode -->
<div
  *ngIf="mode === 'create' && showDrafts && draftRequests.length > 0"
  class="mt-6"
>
  <div class="card">
    <div class="documentation-items-container">
      <h5 class="text-2xl text-color font-semibold mt-2 mb-8">
        Brouillons enregistrés
      </h5>
    </div>

    <p-table
      #draftRequeststable
      [value]="draftRequests"
      dataKey="id"
      [rows]="5"
      [rowsPerPageOptions]="[5, 10, 25]"
    >
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 15%">
            <div class="flex justify-center items-center w-full relative">
              <span>Titre</span>
            </div>
          </th>
          <th style="width: 15%">
            <div class="flex justify-center items-center w-full relative">
              <span>Usine</span>
            </div>
          </th>
          <th style="width: 15%">
            <div class="flex justify-center items-center w-full relative">
              <span>Groupe planificateur</span>
            </div>
          </th>
          <th style="width: 15%">
            <div class="flex justify-center items-center w-full relative">
              <span>Poste technique</span>
            </div>
          </th>
          <th style="width: 15%">
            <div class="flex justify-center items-center">Contexte</div>
          </th>
          <th style="width: 10%">
            <div class="flex justify-center items-center">Seuil</div>
          </th>
          <th style="width: 15%">
            <div class="flex justify-center items-center w-full relative">
              <span>Actions</span>
            </div>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-draftRequest>
        <tr [pSelectableRow]="draftRequest">
          <td class="py-4 px-4 font-semibold text-color">
            {{ draftRequest?.data?.title }}
          </td>
          <td class="py-4 px-4 text-color">
            {{ getPlantLabel(draftRequest?.data?.plant) }}
          </td>
          <td class="text-color">
            {{
              getPlannerGroupLabel(
                draftRequest?.data?.plant,
                draftRequest?.data?.plannerGroup
              )
            }}
          </td>
          <td class="text-color">
            {{
              getFunctionalLocationLabel(draftRequest?.data?.functionalLocation)
            }}
          </td>
          <td class="text-color">{{ draftRequest?.data?.context }}</td>
          <td class="text-color">{{ draftRequest?.data?.threshold }}</td>
          <td>
            <div class="flex gap-2">
              <button
                (click)="loadDraft(draftRequest.id)"
                class="btn-primary-disable"
              >
                Éditer
              </button>
              <button
                class="btn-primary btn-primary-red w-full flex items-center justify-center gap-4"
                (click)="deleteDraft(draftRequest.id)"
              >
                <i class="pi pi-trash"></i>
              </button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="font-bold p-6" colspan="7">Aucune donnée disponible.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
